import { ChevronRight, CircleHelp, Info, LogOut, Settings, UserRound, UsersRound } from 'lucide-react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Modal } from '../components/ui';

const destinations = [
  { to: '/profile', label: 'Perfil', icon: UserRound },
  { to: '/social', label: 'Social', icon: UsersRound },
  { to: '/settings', label: 'Ajustes', icon: Settings },
  { to: '/help', label: 'Ajuda', icon: CircleHelp },
  { to: '/about', label: 'Sobre', icon: Info }
];

const errorMessage = (error: unknown) => error instanceof Error
  ? error.message
  : 'Não foi possível sair. Tente novamente.';

export const AppMenu = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const auth = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  const signOut = async () => {
    if (busy) return;
    setBusy(true);
    setError(undefined);
    try {
      await auth.signOut();
      onClose();
    } catch (signOutError) {
      setError(errorMessage(signOutError));
    } finally {
      setBusy(false);
    }
  };

  return <Modal open={open} title="Menu" onClose={onClose}>
    <nav className="app-menu" aria-label="Menu geral">
      {destinations.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} className="app-menu__item" onClick={onClose}>
        <Icon aria-hidden="true" />
        <span>{label}</span>
        <ChevronRight aria-hidden="true" />
      </NavLink>)}
    </nav>
    <div className="app-menu__signout">
      <button type="button" className="app-menu__item" disabled={busy} onClick={() => void signOut()}>
        <LogOut aria-hidden="true" />
        <span>{busy ? 'Saindo…' : 'Sair'}</span>
      </button>
      {error && <p className="auth-message auth-message--error" role="alert">{error}</p>}
    </div>
  </Modal>;
};
